import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';
import inputData from './inputData/lead-generation-survey';
import { TemplateItem } from './types';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'lead-generation-survey',
  title: 'Lead Generation Survey',
  description: 'Discover where your best leads are coming from and identify which marketing channels are driving the strongest results.',
  image: '/images/templates/lead-generation-survey.png',
  tags: ['lead-generation', 'marketing', 'make-sales'],
  popular: true,
  inputData: inputData,
  formPreview: convertDraftParamsToLeadForm(inputData(),
    previewInput
  ),
}

export default template;

